import React, { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LoadTop from "../components/Common/ScrollTop/LoadTop";

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center vh-100 vw-100 bg-white">
    <div className="page-loader"></div>
    <style>{`
      .page-loader {
        width: 64px;
        height: 64px;
        position: relative;
        background-image: linear-gradient(#0a78b5 16px, transparent 0),
          linear-gradient(#ed701f 16px, transparent 0),
          linear-gradient(#ed701f 16px, transparent 0),
          linear-gradient(#0a78b5 16px, transparent 0);
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: left top, left bottom, right top, right bottom;
        animation: rotate 1s linear infinite;
      }

      @keyframes rotate {
        0% {
          width: 64px;
          height: 64px;
          transform: rotate(0deg);
        }
        50% {
          width: 30px;
          height: 30px;
          transform: rotate(180deg);
        }
        100% {
          width: 64px;
          height: 64px;
          transform: rotate(360deg);
        }
      }
    `}</style>
  </div>
);

const HomeNine = lazy(() => import("../pages/home-9"));

const App = () => {
  return (
    <div className="App">
      <LoadTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomeNine />} />
          <Route path="/home-9" element={<HomeNine />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;
